import React from 'react';

/** The Figma gradient CTA pill (54px, #676AF6→#36CEE5, blue glow). */
const CtaButton = ({ children, onClick, disabled = false, type = 'button' }) => (
	<button
		type={type === 'submit' ? 'submit' : 'button'}
		disabled={disabled}
		onClick={onClick}
		className="flex h-[54px] w-full shrink-0 cursor-pointer items-center justify-center rounded-full bg-gradient-to-br from-[#676AF6] to-[#36CEE5] text-[16px] font-bold text-white shadow-[0px_6px_16px_0px_rgba(2,138,253,0.35)] transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
	>
		{children}
	</button>
);

export default CtaButton;
